(function () {
	function initCarousel() {
		const wrapper = document.querySelector(".carrousel-wrapper");
		if (!wrapper) return;

		function checkOverflow() {
			wrapper.classList.toggle(
				"iscarrousel",
				wrapper.scrollWidth > wrapper.clientWidth,
			);
		}

		checkOverflow();
		window.addEventListener("resize", checkOverflow);
	}

	function equalizeStatsH3() {
		const h3s = document.querySelectorAll(".stats-wrapper h3");
		if (!h3s.length) return;

		h3s.forEach((el) => (el.style.minWidth = ""));

		let maxWidth = 0;
		h3s.forEach((el) => {
			maxWidth = Math.max(maxWidth, el.offsetWidth);
		});

		h3s.forEach((el) => {
			el.style.minWidth = maxWidth + "px";
		});
	}

	function initAll() {
		initCarousel();
		equalizeStatsH3();
	}

	if (
		document.readyState === "interactive" ||
		document.readyState === "complete"
	) {
		initAll();
	} else {
		document.addEventListener("DOMContentLoaded", initAll);
	}

	window.addEventListener("load", initAll);
})();
